import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AssessmentParameters.scss";
import CopyRight from "../../Student/Reusablecomponents/Copyright";
import { TabViewValues } from "../../ReusableComponents/CommonFunctions";
import { FaRegEdit } from "react-icons/fa";
// import { RiDeleteBin5Line } from "react-icons/ri";
import { HiMiniPlusSmall } from "react-icons/hi2";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import AddEditParameters from "./AddEditParameters";

const Parameters = () => {
  const [Load, SetLoad] = useState(false);
  const [lovData, setLovData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [AssessmentandLOParameters, SetAssessmentandLOParameters] = useState(
    "AssessmentParameters"
  );
  const [SelectSubject, SetSelectSubject] = useState(1);
  const [parameterValues, setParameterValues] = useState([]);
  const [EditValues, setEditValues] = useState();
  const [LanguageId, SetLanguageId] = useState();
  const [Language, SetLanguage] = useState([]);
  const [OpenForm, CloseForm] = useState(false);
  const tabs = [
    { Name: "Maths", Value: 1 },
    { Name: "Science", Value: 2 },
    { Name: "English", Value: 3 },
  ];
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [Topic, SeTopic] = useState();
  const [SubTopic, SeSubTopic] = useState();
  const [Grade, SeGrade] = useState();
  const [Chapter, SeChapter] = useState();
  const [LearningOutcome, SeLeaningOutcome] = useState();

  // Below is for science
  const [System, SetSystem] = useState();
  const [Stream, SetStream] = useState();
  const [SubSystem, SetSubSystem] = useState();

  const Languages = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/School/GetSubjectCategoryForGrade?LovCategoryId=69`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const languages = res.data.map((sub) => ({
          display: sub.lovDescription,
          value: sub.lovId,
        }));
        SetLanguage(languages);
        SetLanguageId(languages[0].value);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchLovData = async () => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovCategories?SubjectId=${SelectSubject}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      const fetchedData = response.data;
      setLovData(fetchedData);

      const filtered = fetchedData.filter(
        (item) =>
          item.isAssessmentParameter ===
          (AssessmentandLOParameters === "AssessmentParameters" ? 1 : 0)
      );
      setFilteredData(filtered);

      setSelectedCardId(filtered[0]);
      handleCardClick(filtered[0]);
      SetLoad((prev) => !prev);
    } catch (error) {
      console.error("Error fetching LOV data:", error);
    }
  };

  useEffect(() => {
    Languages();
    fetchLovData();
  }, [SelectSubject]);

  const ParameterValues = async (subjectid, lovcategoryid, parentid) => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${subjectid}&LovCategoryId=${lovcategoryid}&ParentLovId=${parentid}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      SetLoad((prev) => !prev);
      return response.data;
    } catch (error) {
      console.error("Error fetching LOV data:", error);
      return [];
    }
  };

  //API for SubTopic,Learning outcomes and SubLearning outcomes for Math
  const LOParameterValuesMath = async (lovcategoryid) => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetMathLOParamDetails?LovCategoryId=${lovcategoryid}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      SetLoad((prev) => !prev);
      return response.data;
    } catch (error) {
      console.error("Error fetching LOV data:", error);
      return [];
    }
  };

  //API for Stream,Sub System,Topic,SubTopic,Learning outcomes for Science
  const LOParameterValuesScience = async (lovcategoryid) => {
    SetLoad((prev) => !prev);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/NCLAdmin/GetScienceLOParamDetails?LovCategoryId=${lovcategoryid}`,
        {
          headers: { XApiKey: process.env.REACT_APP_XApiKey },
        }
      );
      SetLoad((prev) => !prev);
      return response.data;
    } catch (error) {
      console.error("Error fetching LOV data:", error);
      return [];
    }
  };

  const handleEditClick = (Row) => {
    CloseForm(!OpenForm);
    setEditValues(Row);
    SeTopic(Row?.topicId);
    SeSubTopic(Row?.subtopicId);
    SeLeaningOutcome(Row?.learningOutcomeId);
    SetSystem(Row?.systemId);
    SetStream(Row?.streamId);
    SetSubSystem(Row?.subSystemId);
  };

  const AddParameterForm = () => {
    CloseForm(!OpenForm);
    setEditValues();
  };

  // Below is for science
  const handleCardClick = async (FullCard, StoreInput) => {
    setSelectedCardId(FullCard);

    let fetchedParameters;
    if (
      FullCard?.lovCategoryId === 5 ||
      FullCard?.lovCategoryId === 40 ||
      FullCard?.lovCategoryId === 41
    ) {
      fetchedParameters = await LOParameterValuesMath(FullCard?.lovCategoryId);
    } else if (
      FullCard?.lovCategoryId === 23 ||
      FullCard?.lovCategoryId === 24 ||
      FullCard?.lovCategoryId === 25 ||
      FullCard?.lovCategoryId === 26 ||
      FullCard?.lovCategoryId === 27
    ) {
      fetchedParameters = await LOParameterValuesScience(
        FullCard?.lovCategoryId
      );
    } else {
      fetchedParameters = await ParameterValues(
        SelectSubject,
        FullCard?.lovCategoryId,
        0
      );
    }

    if (StoreInput) {
      setParameterValues([, ...fetchedParameters]);
    } else {
      setParameterValues(fetchedParameters);
    }
  };

  const ChangeCards = (RadioValues) => {
    SetAssessmentandLOParameters(RadioValues);
    let filtered;
    if (RadioValues === "AssessmentParameters") {
      filtered = lovData.filter((item) => item.isAssessmentParameter === 1);
    } else {
      filtered = lovData.filter((item) => item.isAssessmentParameter === 0);
    }
    setFilteredData(filtered);
    handleCardClick(filtered?.[0]);
  };

  const Columns = [
    ...(parameterValues?.[0]?.systemId
      ? [
          {
            name: "System",
            selector: "systemName",
            sortable: true,
          },
        ]
      : []),
    ...(parameterValues?.[0]?.streamId
      ? [
          {
            name: "Stream",
            selector: "streamName",
            sortable: true,
          },
        ]
      : []),
    ...(parameterValues?.[0]?.subSystemId
      ? [
          {
            name: "Sub-System",
            selector: "subSystemName",
            sortable: true,
          },
        ]
      : []),

    ...(parameterValues?.[0]?.topicId
      ? [
          {
            name: "Topic",
            selector: "topicName",
            sortable: true,
          },
        ]
      : []),

    ...(parameterValues?.[0]?.subtopicId
      ? [
          {
            name: "Sub Topic",
            selector: "subtopicname",
            sortable: true,
          },
        ]
      : []),

    ...(parameterValues?.[0]?.learningOutcomeId
      ? [
          {
            name: "Learning Outcome",
            selector: "learningOutcome",
            sortable: true,
          },
        ]
      : []),

    {
      name: selectedCardId?.lovCategoryDescription,
      selector: "lovDescription",
      sortable: true,
    },
    ...(parameterValues?.[0]?.gradeId
      ? [
          {
            name: "Grade",
            selector: "gradeName",
            sortable: true,
          },
        ]
      : []),

    ...(parameterValues?.[0]?.chapterId
      ? [
          {
            name: "Chapter",
            selector: "chapterName",
            sortable: true,
          },
        ]
      : []),
    ...(parameterValues?.[0]?.description
      ? [
          {
            name: "Description",
            selector: "description",
            sortable: true,
          },
        ]
      : []),

    ...((SelectSubject.toString() != "3" || selectedCardId?.lovCategoryDescription === "Grammar")
      ? [
          {
            name: "Action",
            cell: (row) => (
              <div
                className="dflex JCCenter"
              >
                <FaRegEdit
                  title="Edit"
                  className="CPointer"
                  onClick={() => {
                    handleEditClick(row);
                  }}
                  style={{ color: "#624DE3" }}
                  size={18}
                />
                {/* <RiDeleteBin5Line
            title="Delete"
            className="CPointer"
            style={{ color: "#FD3333" }}
            size={18}
          /> */}
              </div>
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="TeacherBgImage">
        <div className="MainHeading" style={{ marginTop: "10px" }}>
          Assessment and LO Parameters
        </div>
        <div className="dflex"
          style={{
            justifyContent: "center",
            position: "relative",
          }}
        >
          <TabViewValues
            Tabs={tabs}
            Selectedtab={SelectSubject}
            onClick={(value) => SetSelectSubject(value)}
          />
          {/* <div style={{ position: 'absolute', right: '0', display: 'flex', alignItems: 'center' }}>
              <label  style={{ marginRight: '10px', fontWeight: 'bold' }}>
                Language
              </label>
              {LanguageId && (
                <DropdownValues
                  className="NCLDropdown"
                  options={Language}
                  onChange={(e) => SetLanguageId(e.target.value)}
                  selectoption={LanguageId}
                />
               )}
            </div> */}
        </div>
        <div
          className="dflex JSBetween alignitems Details mt-2 JCCenter alignitems"
        >
          <div>
            <div className="dflex Subjects">
              <span>
                <input
                  type="radio"
                  name="Assessment&LOParameters"
                  value="AssessmentParameters"
                  checked={AssessmentandLOParameters === "AssessmentParameters"}
                  onChange={(e) => ChangeCards(e.target.value)}
                />{" "}
                Assessment Parameters{" "}
              </span>
              <span>
                <input
                  type="radio"
                  name="Assessment&LOParameters"
                  value="LOParameters"
                  checked={AssessmentandLOParameters === "LOParameters"}
                  onChange={(e) => ChangeCards(e.target.value)}
                />{" "}
                LO Parameters{" "}
              </span>
            </div>
          </div>
        </div>

        <div className="cards-container CPointer" >
          {filteredData.map((item) => (
            <div
              className={`Card ${
                selectedCardId?.lovCategoryId === item.lovCategoryId
                  ? "selected-card"
                  : ""
              }`}
              key={item.lovCategoryId}
              onClick={() => handleCardClick(item)}
            >
              <h7>{item.lovCategoryDescription}</h7>
            </div>
          ))}
        </div>
        {parameterValues.length > 0 &&
          LanguageId !== "7630" &&
          SelectSubject != "3" && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <button
                className="Buttons AddButton mt-2"
                onClick={AddParameterForm}
              >
                <HiMiniPlusSmall />
                Add Parameter{" "}
              </button>
            </div>
          )}

        <DataTable
          data={parameterValues}
          columns={Columns}
          className="NCLDataTable Card mt-3"
          style={{ marginTop: "40px" }}
          Dropdownvalues={["10", "25", "50", "100"]}
          ShowPagination={true}
          ShowPagecount={true}
        />
        {/* <CopyRight /> */}
      </div>
      {OpenForm && (
        <div className="Model-Open">
          <AddEditParameters
            Cancle={CloseForm}
            SubjectId={SelectSubject}
            LanguageId={LanguageId}
            fetchedParameters={parameterValues}
            EditValues={EditValues}
            selectedCardId={selectedCardId}
            handleCardClick={handleCardClick}
            CloseForm={CloseForm}
          />
        </div>
      )}
      {Load && <Loading />}
    </>
  );
};

export default Parameters;
